module.exports = __webpack_public_path__ + "img/new_customers.d2729bda.svg";